import _mixin from "@/components/BuilderComponentsConfig/_mixin";

const defaultImg1 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/c38a23d1725579c2e6c4220813df8a2f.png'
const defaultImg2 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/8cb8d335115bad40f77e77aef495d5a0.png'
const defaultImg3 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/7ca4a61707877a36239350ddca57efb5.png'
const defaultImg4 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/971b1f3a7639443569948f145eb23645.png'
const defaultImg5 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/1ee99d434b1b96f27a3bedca061ec422.png'
const defaultImg6 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/720c123a56b6380771730de5602691f3.png'
const defaultImg7 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/5e65ea069448a36856f6cdbf1eb8d5cd.png'
const defaultImg8 = 'https://rescdn-crash.ssjj.cn/website/2025/03/13/5500ca83573d6ea3dcbdba7f3e85bf54.png'

export default {
  name: 'SVersionNav',
  cnName: '锚点导航',
  type: 'activity_version',
  // 属性相关
  props: {
    list: [
      { targetId: '', default: defaultImg1, active: defaultImg1 },
      { targetId: '', default: defaultImg2, active: defaultImg2 },
      { targetId: '', default: defaultImg3, active: defaultImg3 },
      { targetId: '', default: defaultImg4, active: defaultImg4 },
      { targetId: '', default: defaultImg5, active: defaultImg5 },
      { targetId: '', default: defaultImg6, active: defaultImg6 },
      { targetId: '', default: defaultImg7, active: defaultImg7 },
      { targetId: '', default: defaultImg8, active: defaultImg8 }
    ],
    itemSize: '341px 98px',
    itemMargin: '0 0 5px 0'

  },
  propsDesc: [
    {
      target: 'list',
      label: '锚点列表',
      formType: 'list',
      listConfig: [
        {
          title: '锚点ID',
          target: 'targetId'
        },
        {
          title: '默认图',
          target: 'default'
        },
        {
          title: '选中图',
          target: 'active'
        }
      ]
    },
    {
      target: 'itemSize',
      label: 'item尺寸',
      formType: 'size'
    },
    {
      target: 'itemMargin',
      label: 'item间距'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles,
    position: 'fixed',
    right: '0',
    top: '300px',
    height: 'auto',
    'z-index': '999'
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
